module.exports = __webpack_public_path__ + "static/york_laptop_new-fc7105cea29d445e41fd4883a582be04.png";